export enum RefundRequestStatusEnum {
  "Active" = 1,
  "In_Progress" = 2,
  "Accepted" = 3,
  "Approved" = 4,
  "Completed" = 5,
  "Cancelled" = 6,
  "Refunded" = 7,
  "Rejected" = 8,
  "Pending" = 9,
  "Failed" = 10,
  "Expired" = 11,
  "Deleted" = 12,
}

export enum RefundRequestTypeEnum {
  "Full" = 1,
  "Partial" = 2,
}
